export const ML_URL =
  "https://www.mercadolivre.com.br/planner-vencedor--jogador-de-futebol-2026/up/MLBU3677972295";

export const IG_URL = "https://www.instagram.com/plannerjogadordefutebol/";

export const PRODUCT_IMG = "/img/planner.png";

export const VIDEO_SRC = "/img/video.mp4";
